import { useDeferredValue, type RefObject } from "react";
import { Popover } from "@/components/common/Popover";
import type { ChatListEntry } from "@/lib/chat";
import { EnvironmentChatRow } from "./EnvironmentChatRow";

const POPOVER_WIDTH = 620;
/** 一覧の最大高さ (px)。これを超えるとポップオーバー内でスクロールする。 */
const LIST_MAX_HEIGHT = 360;
/**
 * 開いた直後に描く行数。一覧の最大高さを埋めるのに足りる数だけ先に描いて即座に開き、
 * 残りは後から描く (全件を一度に描くと件数が多いときに開くまで待たされる)。
 */
const INITIAL_ROWS = 10;

interface EnvironmentChatsPopoverProps {
	chats: readonly ChatListEntry[];
	/** 開閉ボタン。ここへのクリックは外側クリックとして扱わない (ボタン側がトグルする)。 */
	anchorRef: RefObject<HTMLElement | null>;
	onSelect: (chatId: string) => void;
	onClose: () => void;
}

/** エージェントのチャットをすべて並べる。外側クリックか Escape で閉じる。 */
export function EnvironmentChatsPopover({
	chats,
	anchorRef,
	onSelect,
	onClose,
}: EnvironmentChatsPopoverProps) {
	const visibleChats = useDeferredValue(chats, chats.slice(0, INITIAL_ROWS));
	return (
		<Popover
			anchorRef={anchorRef}
			onClose={onClose}
			anchored
			dimBackground
			width={POPOVER_WIDTH}
			testId="environment-chats-popover"
		>
			<div
				style={{
					padding: "8px 12px",
					borderBottom: "var(--pane-header-border)",
					fontSize: "var(--text-caption)",
					fontWeight: 500,
					color: "var(--fg-2)",
				}}
			>
				すべてのチャット ({chats.length} 件)
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					maxHeight: LIST_MAX_HEIGHT,
					overflowY: "auto",
				}}
			>
				{visibleChats.map((chat, index) => (
					<EnvironmentChatRow
						key={chat.id}
						chat={chat}
						first={index === 0}
						onSelect={() => onSelect(chat.id)}
					/>
				))}
			</div>
		</Popover>
	);
}
